import React, { useContext } from "react";
import { Card, EmptyState, Layout, Page, Text } from "@shopify/polaris";
import { AppContext } from "../../../../../components/global/appContext";
import { useTranslation } from "react-i18next";
export default function ThemeSettingsEmptyState() {
  const { enabledFeatures } = useContext(AppContext);
  const { t } = useTranslation();
  
  return (
    <Page>
      <Card sectioned>
        <EmptyState
          heading={t("themes.emptyStates.settings.heading")}
          image="https://cdn.shopify.com/s/files/1/2376/3301/products/emptystate-files.png"
          action={
            enabledFeatures?.includes("custom_themes")
              ? {
                  content: t("themes.emptyStates.settings.createSettings"),
                  url: `/themes/live/settings`,
                }
              : { content: t("themes.emptyStates.settings.upgradePlan"), url: "/plan" }
          }
        >
          <p>
            <Text variant="bodyMd" as="span">{t("themes.emptyStates.settings.description")}</Text>
          </p>
          {enabledFeatures?.includes("custom_themes") || (
            <p>
              <Text  variant="bodyMd" as="span" color="critical">{t("themes.emptyStates.settings.upgradeRequired")}</Text>
            </p>
          )}
        </EmptyState>
      </Card>
    </Page>
  );
}
